module.exports = "images/dwg-big.png";